import { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';

const ConfirmBookingModal = ({ show, onClose, onSubmit, loading }) => {
    const [checked, setChecked] = useState(false);

    useEffect(() => {
        if (show) setChecked(false);
    }, [show]);

    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Confirm this booking?</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <p className="mb-3">
                    Please confirm that the motorcycle is available for the selected dates.
                </p>

                <Form.Check
                    type="checkbox"
                    id="confirm-availability"
                    label="I confirm the motorcycle is available for this booking."
                    checked={checked}
                    onChange={(e) => setChecked(e.target.checked)}
                />
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={onClose} disabled={loading}>
                    Back
                </Button>
                <Button
                    variant="success"
                    disabled={!checked || loading}
                    onClick={onSubmit}
                >
                    Confirm Booking
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmBookingModal;